<template>
  <div class="warp">
    <div class="head">
      <div class="head_left">
        <div class="logo">
          <img src="@/assets/image/logo.png" alt="logo">
        </div>
        <div class="title">
          <img src="@/assets/image/title.png" alt="常德市人大常委会组成人员服务专区">
        </div>
      </div>
      <div class="head_right">
        <el-dropdown @command="DropdownHandler">
          <div class="el-dropdown-link user_gro">
            <div>
              <div class="userinfo">
                <span class="user">{{ user.name }}</span>
                <!-- <el-tag
                  size="mini"
                  color="#FFD7DA"
                > 管理员 </el-tag> -->
              </div>
              <!--              <div class="info">{{ user.company }}</div>-->
            </div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <!-- <span class="">
                下拉菜单
              </span> -->
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            <el-dropdown-item command="password">修改密码</el-dropdown-item>
            <el-dropdown-item v-if="role['user']" command="user">系统管理</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="islink">常德人大网</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/' }">常委会服务专区</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index" :to="item.to">{{ item.text }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <i class="el-icon el-icon-s-home"></i>
    </div>
    <div class="content">
      <transition name="fade-transform" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <el-dialog class="addDialog" title="修改密码" :visible.sync="formDialog1.formVisible" @close="cancelForm('form1')">
      <el-form ref="form1" :model="form1" :rules="rules1" label-width="100px" size="small">
        <div class="info">
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="原密码" prop="oldPwd">
                <el-input v-model="form1.oldPwd" show-password placeholder="请输入原密码" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="新密码" prop="newPwd">
                <el-input v-model="form1.newPwd" show-password placeholder="请输入新密码" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="确认新密码" prop="checkPwd">
                <el-input v-model="form1.checkPwd" show-password placeholder="请确认新密码" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formDialog1.formVisible = false">取消</el-button>
        <el-button type="good" @click="submitForm1('form1')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tag,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Row,
  Col,
  Dialog,
  Button,
  Message
} from 'element-ui';
import {
  updatePwd
} from '@/api/user/index'
import {
  getById
} from '@/api/meet/index'
import {
  logout
} from '@/api/sys/login'
import storage from 'store'
let CryptoJS = require('crypto-js');
export default {
  components: {
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [Tag.name]: Tag,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [DropdownItem.name]: DropdownItem,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.name]: Dialog
  },
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form1.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      role: {},
      form1: {
        "oldPwd": "",
        "newPwd": "",
        "checkPwd": ""
      },
      formDialog1: {
        loading: false,
        formVisible: false
      },
      breadcrumb: [],
      rules1: {
        oldPwd: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        },
        {
          min: 8,
          max: 20,
          message: '长度在 8 到 20 个字符',
          trigger: 'blur'
        }],
        newPwd: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        },
        {
          min: 8,
          max: 20,
          message: '长度在 8 到 20 个字符',
          trigger: 'blur'
        }],
        checkPwd: [{
          required: true,
          message: '请再次输入新密码',
          trigger: 'blur'
        },
        {
          min: 8,
          max: 20,
          message: '长度在 8 到 20 个字符',
          trigger: 'blur'
        },
        {
          validator: validatePass,
          trigger: "blur",
          required: true
        }]
      },
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        this.getBreadcrumb(to, from)
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.role = storage.get('role') || {};
    this.user = storage.get('User-Info') || {};
  },
  methods: {
    getBreadcrumb (to, from) {
      let a = []
      if (to.fullPath.includes('/files/')) {
        getById(to.params.id).then(res => {
          if (res.status === 1) {
            let type = res.data.type
            if (type === '1') {
              a.push(
                {
                  text: '常委会会议资料',
                  to: '/meeting/cw',
                }
              )
            } else if (type === '2') {
              a.push(
                {
                  text: '代表大会会议资料',
                  to: '/meeting/db',
                },
              )
            } else if (type === '3') {
              a.push(
                {
                  text: '主任会议资料',
                  to: '/meeting/zr',
                }
              )
            }else if (type === '5') {
              a.push(
                {
                  text: '审议意见卡',
                  to: '/meeting/syyjk',
                }
              )
            }
            a.push({
              text: res.data.name
            })
            storage.set('title', res.data.name)
            this.breadcrumb = a;
          }
        })
      } else {
        a.push({
          text: to.meta.title
        })
        this.breadcrumb = a;
      }
    },
    //加密方法
    aesEncrypt (content) {
      let key = CryptoJS.enc.Utf8.parse('lkjwmnnvflkdj85f');
      let srcs = CryptoJS.enc.Utf8.parse(content);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    submitForm1 (formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let j = JSON.parse(JSON.stringify(that.form1))
          j.oldPwd = that.aesEncrypt(j.oldPwd);
          j.newPwd = that.aesEncrypt(j.newPwd);
          updatePwd(j).then(res => {
            if (res.status == 1) {
              Message({
                type: 'success',
                message: '修改成功！正在退出，请重新登录',
                onClose () {
                  that.logoutHandler();
                }
              });
              that.formDialog1.formVisible = false;

            }
          })
        }
      });
    },
    cancelForm (formName) {
      this.$refs[formName].resetFields();
    },
    chongzhiHandler () {
      this.formDialog1.formVisible = true;
    },
    logoutHandler () {
      logout().then(res => {
        storage.remove('Access-Token');
        this.$router.push({
          path: '/login'
        })
      })
    },
    DropdownHandler (type) {
      if (type === 'user') {
        this.$router.push({
          path: '/user'
        })
      } else if (type === 'password') {
        this.chongzhiHandler();
      } else if (type === 'logout') {
        this.logoutHandler();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-menu {
  .el-dropdown-menu__item {
    min-width: 100px;
  }
}

.warp {
  max-width: 1400px;
  margin: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .head_left {
    display: flex;
    align-items: center;

    .logo {
      width: 52px;
      height: 60px;
    }

    .title {
      width: 690px;
      height: 50px;
    }
  }

  .head_right {
    .user_gro {
      display: flex;
      align-items: center;
    }

    .userinfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .el-tag--mini {
      border-radius: 50px;
      color: #f96569;
      border: 0;
      line-height: 22px;
    }

    .user {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #f84148;
      line-height: 24px;
    }

    .info {
      color: #999;
      font-size: 14px;
    }
  }
}

.breadcrumb {
  position: relative;
  padding: 16px 20px 20px;

  .el-icon {
    position: absolute;
    left: 0;
    top: 17px;
    // transform: translateY(-50%);
    color: #606266;
  }

  .el-breadcrumb {
    font-size: 16px;
    line-height: 20px;

    ::v-deep .el-breadcrumb__inner {
      color: #f84148;
      font-weight: 900;

      &.is-link {

        color: #606266;
        font-weight: 400;

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }

  .islink ::v-deep .el-breadcrumb__inner {
    color: #606266;
    font-weight: 400;
  }
}

.content {
  flex-grow: 1;
  background: #ffffff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0px 0px 32px 0px rgba(119, 17, 17, 0.18);
}

.svgicon {
  width: 20px;
  height: 30px;
  fill: #bcbcbc;
  cursor: pointer;
  margin-right: 10px;
}
</style>